import React, {useEffect, useState} from 'react';
import {Container, Typography, Box } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {useHistory, useLocation, useParams} from "react-router-dom";
import {requestApi, showAlertAutoDis, validateForm} from "../utils/utils";
import { PaymentHeaderStripe, PaymentHeaderFlywire } from "../components/Booking/Payment/PaymentNew";
import Payment from "../components/Booking/Payment/Payment";
import {Elements} from "@stripe/react-stripe-js";
import CheckoutForm from "../components/Booking/Payment/CheckoutForm";
import CheckoutFormFlywire from "../components/Booking/Payment/CheckoutFormFlywire";
import {loadStripe} from "@stripe/stripe-js/pure";
import Icon from '@mui/material/Icon';
import {format, parse} from "date-fns";
import * as yup from "yup";

let billingDetailsValidation = yup.object().shape({
    country: yup.string().required('The country is required'),
    state: yup.string().required('The state is required'),
    address_city: yup.string().required('The city is required'),
    address_line1: yup.string().required('The address is required'),
    address_zip: yup.string().required('The Zip code is required'),
    name: yup.string().required('The Name is required'),
    email: yup.string().required('The Email is required'),
});

const AnonymousPaymentPageNew = () => {
    const [booking, setBooking] = useState(null);
    const {stripeKey} = window;
    const [payments, setPayments] = useState([]);
    const [stripePromise, setStripePromise] = useState(false);
    const [payThisMuch, setPayThisMuch] = useState(0.0);
    const [billingDetails, setBillingDetails] = useState({
        country: '',
        state: '',
        address_city: '',
        address_line1: '',
        address_line2: '',
        address_zip: '',
        email: '',
        name: ''
    });
    const [allowPay, setAllowPay] = useState(false);
    const [message, setMessage] = useState('');
    const {id} = useParams();
    const {search} = useLocation();
    const searchParams = new URLSearchParams(search);
    const crsUser = searchParams.get("crs");
    const queryString = crsUser ? `?crs=${crsUser}` : '';
	const [expanded, setExpanded] = useState('panel1');

    const history = useHistory();

	const handleChangeAccordeon = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    const {siteUrl} = window;

    useEffect(() => {
        getBookingById().catch();
        setStripePromise(loadStripe(stripeKey));
    }, []);


    useEffect(() => {
        if (booking){
            checkTerms();
            checkToPay().catch();
        }
    }, [booking?.id]);

    const checkToPay = async () => {
        const url = `/crs/check-to-pay/${booking.id}${queryString}`;
        const {data} = await requestApi(url, 'POST');

        if (data.status === 'success') {
            const allow = !!data?.allowed_payment;
            setAllowPay(allow);
            if (!allow && data.message)
                setMessage(data.message);
        }
    };
    const checkTerms = () => {
        if(booking && parseInt(booking.termsAccepted) === 0)
            return history.push(`/booking/terms/${booking.id}`);
    };

    const getBookingById = async () => {
        try {
            const withConfirmationNumber = id.length >= 15;
            const params = {};
            if(crsUser)
                params['crs'] = crsUser;
            if (withConfirmationNumber)
                params['confirmation'] = id;
            else
                params['id'] = id;

            const {data} = await requestApi(`/get-booking-by-confirmation`, 'POST', params);
            if (data.status === 'failed') return history.push('/');
            setBooking(data.booking);
            setEmailAndName(data.booking)
            setPayments(data.paySchedule.payschedule);
        } catch (e) {
            return history.push('/');
        }
    };

    const setEmailAndName = (booking) => {
        setBillingDetails({...billingDetails, email: booking.ClientEmail || '', name: booking.clientname || ''});
    };

    const setDetails = (event) => {
        setBillingDetails({...billingDetails, [event.target.name]: event.target.value});
    };

    const sendStripeToken = async (token) => {
        if (!await validateForm(billingDetailsValidation, billingDetails, 'Billing Details Form')) return;
        const paymentData = {
            amount: payThisMuch,
            billingDetails
        };

        const {
            name,
            brand,
            address_line1,
            address_city,
            address_zip,
            cvc_check,
            address_zip_check,
            country,
            last4
        } = token.card;

        paymentData.cardInfo = {
            name,
            brand,
            address_line1,
            address_city,
            address_zip,
            cvc_check,
            address_zip_check,
            country,
            last4
        };

        paymentData.token = token.id
        paymentData.created = token.created;

		await requestApi(`/crs/payment/${booking.id}${queryString}`, 'POST', paymentData, ({ data }) => {
            let successPayment = false;
            if ('status' in data && data['status'] === 'success') {
                successPayment = !!data['successPayment'];
                if (successPayment)
                    showAlertAutoDis({title: 'Success', text: 'Payment successful', manualClose: true}, () => {
						history.push(`/`);
					});
            } else if ('message' in data)
                showAlertAutoDis({ title: 'Error', text: data['message'] });
        });
    };

	const sendFlywireToken = async (token) => {
        const paymentData = {
            amount: payThisMuch,
            billingDetails: {
                name: billingDetails['name'],
                email: billingDetails['email'],
            }
        };
        const {
            amount,
            amountCurrency,
            digits,
            expirationMonth,
            expirationYear,
            payerAmount,
            payerAmountCurrency,
            paymentMethod,
            reference,
            sig,
            status,
        } = token;
        paymentData.cardInfo = {
            amount,
            amountCurrency,
            digits,
            expirationMonth,
            expirationYear,
            payerAmount,
            payerAmountCurrency,
            paymentMethod,
            reference,
            sig,
            status,
        };
        paymentData.token = token.token;


        await requestApi(`paymentFlywire/${booking.id}`, 'POST', paymentData, ({ data }) => {
            let successPayment = false;

            if ('status' in data && data['status'] === 'success') {
                successPayment = !!data['successPayment'];
                if (successPayment)
                    showAlertAutoDis({title: 'Success', text: 'Payment successful', manualClose: true}, () => {
						history.push(`/`);
					});
            } else if ('message' in data)
                showAlertAutoDis({ title: 'Error', text: data['message'] });
        });
    };


    return (
        <>
            {allowPay && <Container sx={{marginTop: '20px'}} maxWidth="lg">
                <Typography align={'center'} variant={'h4'} style={{marginBottom: '5px'}}>
                    Booking Confirmation: #{booking.Confirmation}
                </Typography>
                <Typography align={'center'} variant={'h4'} style={{marginBottom: '5px'}}>
                    Trip Date: {format(parse(booking.tripDate, 'yyyy-MM-dd', new Date()), 'LLLL d, yyyy')}
                </Typography>
                <Typography align={'center'} variant={'h4'} style={{marginBottom: '5px'}}>
                    {booking.trip.location.location}
                </Typography>
                <Typography align={'center'} variant={'h4'} style={{marginBottom: '20px'}}>
                    {booking.trip.trip_class_info.class}
                </Typography>
                {/* <Payment paySchedule={payments} payThisMuch={payThisMuch}
                         setPayThisMuch={(amount) => setPayThisMuch(parseFloat(amount))}
                         allowCustomPay={parseInt(booking['Type'])===2 || crsUser}/> */}

                {/* {payThisMuch > 0 && <div style={{marginTop: 30}}>
                    <Typography align={'center'} id="transition-modal-title" variant={'h3'}>
                        Pay Now $ {payThisMuch.formatMoney()} USD
                    </Typography>
                    {stripePromise && <Elements stripe={stripePromise}>
                        <CheckoutForm
                            setBilling={setDetails}
                            billingDetails={billingDetails}
                            sendStripeToken={sendStripeToken}/>
                    </Elements>}
                </div>} */}

				<Box sx={{ backgroundColor: '#E7EBF0', padding: '20px', borderRadius: '10px' }}>
                    <Accordion expanded={expanded === 'panel1'} onChange={handleChangeAccordeon('panel1')} sx={{ backgroundColor: '#FFF', marginBottom: '20px' }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ fontSize: '26px !important' }} />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            <Typography variant="h6" component="h6" sx={{ fontSize: '20px', fontWeight: '400' }}>
                                USD Payment
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {payments && payments.length > 0 && allowPay &&
                                <PaymentHeaderStripe
                                    paySchedule={payments}
                                    payThisMuch={payThisMuch}
                                    setPayThisMuch={value => setPayThisMuch(parseFloat(value))}
                                    allowCustomPay={parseInt(booking['Type']) === 2 || crsUser}
                                />
                            }
                            {payThisMuch > 0 &&
                                <div style={{ marginTop: 30 }}>
                                    <Typography align={'center'} id="transition-modal-title" variant={'h3'}>Pay Now $ {payThisMuch.formatMoney()} USD</Typography>
                                    {stripePromise &&
                                        <Elements stripe={stripePromise}>
                                            <CheckoutForm
                                                setBilling={setDetails}
                                                billingDetails={billingDetails}
                                                sendStripeToken={sendStripeToken}
                                            />
                                        </Elements>
                                    }
                                </div>
                            }
                            {!allowPay && message && <Typography align={'center'} variant={'body1'}>
                                <Icon sx={{ fontSize: '140px', marginTop: '20px', marginBottom: '20px' }}>warning_amber</Icon><br />
                                {message}
                            </Typography>}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel2'} onChange={handleChangeAccordeon('panel2')} sx={{ backgroundColor: '#FFF' }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ fontSize: '26px !important' }} />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                        >
                            <Typography variant="h6" component="h6" sx={{ fontSize: '20px', fontWeight: '400' }}>
                                Local Currency Payment
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {payments && payments.length > 0 && allowPay &&
                                <PaymentHeaderFlywire
                                    paySchedule={payments}
                                    payThisMuch={payThisMuch}
                                    setPayThisMuch={value => setPayThisMuch(parseFloat(value))}
                                    allowCustomPay={parseInt(booking['Type']) === 2 || crsUser}

                                />
                            }
                            {payThisMuch > 0 &&
                                <div style={{ marginTop: 30 }}>
                                    <Typography align={'center'} id="transition-modal-title" variant={'h3'}>Pay Now
                                        ${payThisMuch.formatMoney()} USD
                                    </Typography>
                                    <CheckoutFormFlywire
                                        bookingId={booking.id}
                                        payThisMuch={payThisMuch}
                                        billingDetails={billingDetails}
                                        sendFlywireToken={sendFlywireToken}
                                        returnURLDestination={siteUrl}
                                    />
                                </div>
                            }
                            {!allowPay && message && <Typography align={'center'} variant={'body1'}>
                                <Icon sx={{ fontSize: '140px', marginTop: '20px', marginBottom: '20px' }}>warning_amber</Icon><br />
                                {message}
                            </Typography>}
                        </AccordionDetails>
                    </Accordion>
                </Box>
            </Container>}
            {!allowPay && message && <Container sx={{marginTop: '20px'}}>
                <Typography align={'center'} variant={'body1'}>
                    <Icon sx={{fontSize: '140px', marginTop: '20px', marginBottom: '20px'}}>warning_amber</Icon><br/>
                    {message}
                </Typography>
            </Container>
            }
        </>
    );
};

export default AnonymousPaymentPageNew;